import { useState } from 'react'

/**
 * Hook para manejar un OffCanvas dinámico.
 * Permite definir título, contenido y tamaño opcional.
 *
 * @returns {{
 *   isOpen: boolean,
 *   isLarge: boolean,
 *   config: { title: string, component: React.ReactNode },
 *   open: (title: string, component: React.ReactNode) => void,
 *   openLarge: (title: string, component: React.ReactNode) => void,
 *   close: () => void
 * }}
 */
const useOffCanvas = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isLarge, setIsLarge] = useState(false)
  const [config, setConfig] = useState({ title: '', component: null })

  /**
   * Abre el OffCanvas con contenido dinámico
   */
  const open = (title, component) => {
    setConfig({ title, component })
    setIsLarge(false) // aseguramos que no sea grande por defecto
    setIsOpen(true)
  }

  /**
   * Abre el OffCanvas en modo grande
   */
  const openLarge = (title, component) => {
    setConfig({ title, component })
    setIsLarge(true)
    setIsOpen(true)
  }

  /**
   * Cierra el OffCanvas
   */
  const close = () => {
    setIsOpen(false)
    setIsLarge(false)
    setConfig({ title: '', component: null })
  }

  return {
    isOpen,
    isLarge,
    config,
    open,
    openLarge,
    close,
  }
}

export default useOffCanvas
